module.exports = __webpack_public_path__ + "img/p.5b7cef11.jpg";